import React from 'react';

import Loader from '@amzn/meridian/loader';
import Row from '@amzn/meridian/row';

interface LoadingSpinnerProps {
  label?: string;
}

const LoadingSpinner = ({ label = 'Loading' }: LoadingSpinnerProps) => {
  return (
    <div role="progressbar" aria-label={label}>
      <Row alignmentHorizontal="center" alignmentVertical="center" spacingInset="500">
        <Loader />
      </Row>
    </div>
  );
};

export default LoadingSpinner;
